import type { ApiResponse, PaginatedData, SuccessResponse, User } from "@shared/types";
import apiClient from "@/app/api/client";

interface ListUsersParams {
	page?: number;
	limit?: number;
	phone?: string;
}

// Read-only: the admin panel doesn't manage staff accounts yet, it only needs
// to resolve "which user gave this aid" in the aid-records form.
export const usersService = {
	async list(params: ListUsersParams): Promise<PaginatedData<User>> {
		const response = await apiClient.get<ApiResponse<PaginatedData<User>>>("/users", { params });
		return (response.data as SuccessResponse<PaginatedData<User>>).data;
	},
};
